module.exports = __webpack_public_path__ + "static/media/ACM-Parivartan-light.5f9fd4c4.jpeg";